
export enum PreviewMode
{
    LivePreview = "live-preview",
    SnapshotView = "snapshot-view"
}
